import BankAccountSelector from './BankAccountSelector'

export default BankAccountSelector
